<script setup lang="ts">
let countdownInterval: ReturnType<typeof setTimeout>;
const newYearsEve = new Date(2026, 0, 1).getTime();
const offset = 300 * 60 * 1000;
const displayCountdown = ref(true);

const countdownValues = ref({
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00',
});

onMounted(() => {
  countdownInterval = setInterval(() => {
    doCountdown();
  }, 500);
});

function getCountDown() {
  const timeToNewYears = new Date(newYearsEve - new Date().getTime() + offset);
  countdownValues.value.days = Math.floor(timeToNewYears.valueOf() / (1000 * 3600 * 24))
    .toString()
    .padStart(2, '0');
  countdownValues.value.hours = ('0' + timeToNewYears.getHours()).slice(-2);
  countdownValues.value.minutes = ('0' + timeToNewYears.getMinutes()).slice(-2);
  countdownValues.value.seconds = ('0' + timeToNewYears.getSeconds()).slice(-2);
}

function doCountdown() {
  const rightNow = new Date().getTime();

  if (rightNow < newYearsEve) {
    getCountDown();
  } else {
    clearInterval(countdownInterval);
    displayCountdown.value = false;
  }
}

onUnmounted(() => {
  clearInterval(countdownInterval);
});
</script>

<template>
  <div class="countdown-timer py-[7rem] flex flex-col items-center gap-4">
    <div v-if="displayCountdown" class="text-2xl text-center text-white">
      <h3 class="font-black uppercase">{{ $t('countdown_to_nye') }}</h3>
    </div>

    <div v-if="displayCountdown" class="flex justify-center gap-2 text-white">
      <div class="time-unit w-auto">
        <div class="number">
          {{ countdownValues.days }}
        </div>
        <div class="label">{{ $t('days') }}</div>
      </div>

      <div class="spacer">:</div>

      <div class="time-unit">
        <div class="number">
          {{ countdownValues.hours }}
        </div>
        <div class="label">{{ $t('hours') }}</div>
      </div>

      <div class="spacer">:</div>

      <div class="time-unit">
        <div class="number">
          {{ countdownValues.minutes }}
        </div>
        <div class="label">{{ $t('minutes') }}</div>
      </div>

      <div class="spacer">:</div>

      <div class="time-unit">
        <div class="number">
          {{ countdownValues.seconds }}
        </div>
        <div class="label">{{ $t('seconds') }}</div>
      </div>
    </div>

    <div v-if="!displayCountdown" class="text-2xl">{{ $t('happy_new_year') }}</div>
  </div>
</template>

<style lang="scss" scoped>
.countdown-timer {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  .time-unit {
    font-weight: 900;
    text-align: center;
    &:not(:first-child) {
      width: 14rem;

      @media (max-width: 768px) {
        width: 7rem;
      }

      @media (max-width: 640px) {
        width: 5.5rem;
      }
    }
    .number {
      font-size: 10rem;
      line-height: 1;

      @media (max-width: 768px) {
        font-size: 6rem;
      }

      @media (max-width: 640px) {
        font-size: 4.5rem;
      }
    }

    .label {
      font-size: 2.5rem;
      font-weight: 900;
      text-transform: uppercase;

      @media (max-width: 768px) {
        font-size: 1.75rem;
      }
    }
  }

  .spacer {
    font-size: 6rem;
    font-weight: 900;
    line-height: 1;
    padding-top: 2rem;

    @media (max-width: 768px) {
      font-size: 4rem;
      padding-top: 1rem;
    }

    @media (max-width: 768px) {
      font-size: 3rem;
      padding-top: 1rem;
    }
  }
}
</style>
